import { PluginReview } from 'rwl-shared/dist/models/plugin/Plugin';
import styled from 'styled-components6';
import { ReviewRating } from '../../ReviewRating';
import { Body1 } from '../../../theme';
import { ReviewAuthor } from './ReviewAuthor';

const ReviewContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--rwl-spacing-sm);

    border-radius: var(--rwl-radius-sm);
    padding: var(--rwl-spacing-md);

    /* Elevation/4 */
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
`;

const ReviewRatingContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--rwl-spacing-sm);
`;

const ReviewMessage = styled(Body1)``;

export const JobReview = ({ review }: { review: PluginReview }) => {
    return (
        <ReviewContainer id={'jobReview'}>
            <ReviewRatingContainer>
                <ReviewRating size={'large'} {...review} />
            </ReviewRatingContainer>
            {review.message && <ReviewMessage>{review.message}</ReviewMessage>}
            <ReviewAuthor review={review} />
        </ReviewContainer>
    );
};
